import {request} from "./request";

export function GetTrainingData(cid, start, end) {
  return request({
    url: 'DataCenter/GetTrainingData',
    params: {
      cid, start, end
    }
  })
}

export function GetPhysicalTest() {
  return request({
    url: 'DataCenter/GetPhysicalTest',
  })
}
